import { aiHttpClient } from '../../../Common/api/ai_http_client';

/**
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
export function fetchTriggers() {
  return aiHttpClient.get('/recommendation/triggers');
}

/**
 *
 * @param id
 * @returns {Promise<AxiosResponse<any>>}
 */
export function fetchTriggerSettings(id) {
  return aiHttpClient.get(`/recommendation/settings/${id}`);
}

/**
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
export function fetchDrivers() {
  return aiHttpClient.get('/recommendation/drivers');
}

/**
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
export function fetchTemplates() {
  return aiHttpClient.get('/recommendation/templates');
}

/**
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
export function createTriggers(payload) {
  return aiHttpClient.post('/recommendation/triggers', payload);
}

/**
 *
 * @param id
 * @param payload
 * @returns {Promise<AxiosResponse<any>>}
 */
export function updateTrigger(id, payload) {
  return aiHttpClient.put(`/recommendation/trigger/${id}`, payload);
}

/**
 *
 * @param id
 * @returns {Promise<AxiosResponse<any>>}
 */
export function deleteTrigger(id) {
  return aiHttpClient.delete(`/recommendation/trigger/${id}`);
}
